export default "__VITE_ASSET__fdd45f16__"